export const TYPE_DICTIONARY = {
  ITINENARY_CARD: 'ITINENARY_CARD',
};
export const PREFIXES_DICTIONARIES = [
  {
    id: 'compareDictionary',
    prefix: 'cruiseSearch.compare',
  },
  {
    id: 'favoritesDictionary',
    prefix: 'cruiseSearch.favorites',
  },
  {
    id: 'watchlistDictionary',
    prefix: 'cruiseSearch.watchlist',
  },
  {
    id: 'filtersDictionary',
    prefix: 'cruiseSearch.filters',
  },
  {
    id: 'generalDictionary',
    prefix: 'cruiseSearch.general',
  },
  {
    id: 'itineraryCardsDictionary',
    prefix: 'cruiseSearch.itineraryCards',
  },
  {
    id: 'pricingPanelDictionary',
    prefix: 'cruiseSearch.pricingPanel',
  },
  {
    id: 'bookingDictionary',
    prefix: 'booking.forgotCasidModal',
  }
];
